import React from "react";
import { Sparkles, Leaf, Check, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const AlternativeTherapies = () => {
  const { t } = useLang();
  const s = t.alternative;
  return (
    <section
      id="alternative"
      className="relative py-24 md:py-32 bg-emerald-900 text-white overflow-hidden"
      data-testid="alternative-section"
    >
      <div className="absolute -top-40 -left-40 h-[480px] w-[480px] rounded-full bg-emerald-700/30 blur-3xl" />
      <div className="absolute -bottom-40 -right-40 h-[420px] w-[420px] rounded-full bg-emerald-500/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-3 py-1 text-xs font-semibold tracking-widest uppercase text-emerald-100">
            <Leaf className="h-3.5 w-3.5" /> {s.eyebrow}
          </span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl font-bold tracking-tight">
            {s.title}
          </h2>
          <p className="mt-5 text-lg text-emerald-100/90 leading-relaxed">{s.desc}</p>

          <a
            href="#booking-alt"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-emerald-900 px-6 py-3.5 text-sm font-semibold hover:bg-emerald-50 transition-colors shadow-md"
            data-testid="alternative-cta"
          >
            {s.cta}
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        <div className="lg:col-span-4">
          <div className="rounded-3xl bg-white/5 backdrop-blur-sm border border-white/10 p-7">
            <h3 className="font-display font-semibold text-lg text-white">{s.itemsTitle}</h3>
            <ul className="mt-5 space-y-3">
              {s.items.map((it, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-emerald-50/95">
                  <span className="mt-0.5 inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-emerald-400/20 border border-emerald-300/30 text-emerald-200">
                    <Leaf className="h-3 w-3" />
                  </span>
                  {it}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="rounded-3xl bg-gradient-to-br from-emerald-400 to-emerald-600 p-7 shadow-lg shadow-emerald-900/40 text-white h-full">
            <div className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest">
              <Sparkles className="h-3 w-3" /> {s.benefitsTitle}
            </div>
            <ul className="mt-5 space-y-4">
              {s.benefits.map((b, i) => (
                <li key={i} className="flex gap-3 text-sm leading-relaxed">
                  <span className="mt-0.5 inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-white text-emerald-700">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlternativeTherapies;
